//redirect for gift cards
var delaynew = ms => new Promise(res => setTimeout(res, ms));


  window.onload = (event) => {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      cache: 'no-store'
    }
    )
    .then(res => res.json())
    .then(data => {
      var justGiftCards = true;
      console.log("checking gift cards")
      for(var itemsCount=0;itemsCount<data.items.length;itemsCount++){
        if(data.items[itemsCount].id != 31478736748586 && data.items[itemsCount].id != 31478736781354 && data.items[itemsCount].id != 31478736814122 && data.items[itemsCount].id != 31478736846890 ){
          justGiftCards = false;
        }
      }
      if(justGiftCards == true){
        try{
          window.location.href = "/checkout";
        }
        catch(e){
          console.log(e)
        }
      }
      /*
      if (data.items.length == 1 && data.items[0].id == 31478736748586 || data.items.length == 1 && data.items[0].id == 31478736781354 || data.items.length == 1 && data.items[0].id == 31478736814122 || data.items.length == 1 && data.items[0].id == 31478736846890) {
        console.log("redirect")
        window.location.href = "https://inspiredgo.ca/checkout";
      }
      else {
        console.log("something has gone wrong")
      }
      */
    });
  }

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.getCart().then(data => {
      if (((data || {}).items || []).length > 0) {
        this.updateQuantity(1, data.items[0].quantity, document.activeElement.getAttribute('name'), data.items[0].id);

      }
    });
    this.free_gift_active = false;
    this.free_gift_id= "40483132735530";
    this.free_gift_handle_name = "organika-keto-mini-cookies";
    fetch(`/products/${this.free_gift_handle_name}.js`).then(res=>{
      if(res.status==200){
        this.free_gift_active=true;
      }else{
        this.free_gift_active=false;

      }
    })
  }

  getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((res) => res.json())
      .then((res) => res);
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.product_id);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      //       {
      //         id: 'main-cart-footer',
      //         section: document.getElementById('main-cart-footer').dataset.id,
      //         selector: '.js-contents',
      //       }
    ];
  }

  updateQuantity(line, quantity, name, data_id) {
    this.enableLoading(line);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var view = urlParams.get('view')

    var d = {
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
      "updates": {}
    }
    d["updates"][data_id] = quantity;
    const body = JSON.stringify(d);

    fetch(`/cart/update.js`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
          return response.json();
      })
      .then(async (state) => {
        var filtered = ((state||{}).items || []).filter(item => item.id == this.free_gift_id);
          if (filtered.length>0 && filtered[0].quantity>1){
            d['updates'] = {}
            d["updates"][free_gift_id] =1;
            var res = await fetch("/cart/update.js",{"method":"POST",headers: { "Content-Type": "application/json" },"body":JSON.stringify(d)})
            state = await res.json();
          }
          else if (((state||{}).items || []).length>0 && filtered.length == 0){
            if (this.free_gift_active) {
              delete d['updates']
              d['items'] = [{"id":this.free_gift_id,"quantity":1}]
              var res = await fetch("/cart/add.js",{"method":"POST",headers: { "Content-Type": "application/json" },"body":JSON.stringify(d)})
              if (res.status==200){
                state = await res.json()
              }
            }
          }
          // check for free gift - commented out so that there is no error in cart page when zeroing cart
          else  if ((((state||{}).items || []).length==1 && state.items[0].id==this.free_gift_id)|| !this.free_gift_active){
            d['updates'] = {}
            d["updates"][free_gift_id] =0;
            //var res = await fetch("/cart/update.js",{"method":"POST",headers: { "Content-Type": "application/json" },"body":JSON.stringify(d)})
            //state = await res.json();
            }

        window.dispatchEvent(new CustomEvent("cartUpdatedZapiet"));
        const parsedState = state;
        try {

          document.getElementById(`Quantity-${data_id}`).value = quantity;
        } catch (error) {

        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        var x_section = this.getSectionInnerHTML(parsedState.sections[document.getElementById('main-cart-items').dataset.id], ".totals__subtotal-value");


        if (!$('#cart_subscribe_radio').is(":checked")) {
          var price = parseFloat(x_section.replace("$", ""))
          var total = (price - (price * 5) / 100);
          $('.appstle-subsccribe-cart-discount').html('<b>5% (New Total $' + `${total.toFixed(2)})</b>`);
        }
        else {
          var price = parseFloat(x_section.replace("$", ""))

          $('.appstle-subsccribe-cart-discount').html('<b>5% (New Total $' + `${price.toFixed(2)})</b>`);
        }

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        var comString = window.location.hostname;
        comString = comString.split(".")[1];
        //console.log(queryString);
        
        //const urlParams = new URLSearchParams(queryString);
        var country;
        if(comString == "com"){
          country = "USA"
        }
        else {
          country = "Canada"
        }    

        if(country == "Canada"){
          await update_progress_bar(parsedState);
        }
        
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);


class QuantityInputNew extends HTMLElement {
  constructor() {
    super();
    this.previousValue = 0;
    this.selling_plan_id = "";
    /* this.getCart().then((data => {
      if (((data || {}).items || []).length > 0) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].selling_plan_allocation) {
            this.selling_plan_id = data.items[i].selling_plan_allocation.selling_plan.id;
            break;
          }
        }
      }
    })) */

    this.input = this.querySelector('input') || this.querySelector('.quantity__input');

    this.minusButton = this.querySelector("button[name='minus']");
    this.changeEvent = new Event('change', { bubbles: true });
    this.handleMinusButton();
    if (!this.input) {
      this.input = document.querySelector("quantity-input-new input")
      // return
    }
    this.input.addEventListener("click", () => {
      e.target.setAttribute("oldvalue", e.target.value || 0)
    })
    this.input.addEventListener("change", (e) => {
      this.handleMinusButton();
      const variant_id = e.target.dataset.id;

      this.updateQuantity(variant_id, e.target.value, e.target.oldvalue);
    })

    this.querySelectorAll('button').forEach(
      (button) => {
        button.addEventListener('click', this.onButtonClick.bind(this))
      }
    );


  }

  handleSingle(single_bundle, variant_id, quantity, addon_id) {
    if (single_bundle) {
      setSingleBundle(variant_id, quantity, addon_id)
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    this.previousValue = this.input.value * 1;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
    ];
  }

  async updateQuantity(line, quantity, oldvalue) {
    // var s_d = {
    //   "monday": {
    //     "weekly": "412254250",
    //     "biweekly": "412942378"
    //   },
    //   "sunday": {
    //     "weekly": "411926570",
    //     "biweekly": "411992106"

    //   }
    // }

    var data = {
      id: line,
      quantity
    }
    /* if (!document.getElementById("cart_subscribe_radio").checked) {
      this.selling_plan_id = '';

    } else if (!this.selling_plan_id) {

      var day = $("#day_selection_subscription").val()
      var weekly = $("#appstle_selling_plan_cart_new").val()
      if (day)
        this.selling_plan_id = s_d[day][weekly];

    }

    if (this.selling_plan_id && (quantity == "1" || quantity == 1)) {
      data['selling_plan'] = this.selling_plan_id;
    } */

    if ((quantity === "1" || quantity === 1 || !this.previousValue)) {
      const cart = await this.getCart();
      const sellingPlanName = cart.items[0]?.selling_plan_allocation?.selling_plan?.name;
      const hasBundleProps = !!cart.items[0]?.properties?._rc_bundle;

      if (sellingPlanName) {
        const cartProduct = window.bear.cartProducts.find(item => {
          return !!item.variants.find(item => {
            return parseInt(item.id) === parseInt(line)
          })
        })

        const sellingPlanGroup = cartProduct?.selling_plan_groups?.find(group => group.name === sellingPlanName)

        data.selling_plan = sellingPlanGroup?.selling_plans[0]?.id
      }

      if (hasBundleProps) {
        const { _rc_bundle, _rc_bundle_variant, _rc_bundle_parent, _rc_bundle_collection_id } = cart.items[0].properties
        data.properties = {
          "_rc_bundle": _rc_bundle,
          "_rc_bundle_variant": _rc_bundle_variant,
          "_rc_bundle_parent": _rc_bundle_parent,
          "_rc_bundle_collection_id": _rc_bundle_collection_id
        }
      }

      const body = JSON.stringify(data);

      await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.updateCart(parsedState.variant_id, quantity)
        }).catch((error) => {

          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    } else {
      this.updateCart(line, quantity)
    }
  }

  updateCart(line, quantity) {
    var data = {
      updates: {},
      sections: this.getSectionsToRender().map((section) => section.section)
    }
    data.updates[line] = quantity;
    const body = JSON.stringify(data);
    fetch(`/cart/update.js`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        window.dispatchEvent(new CustomEvent("cartUpdatedZapiet"));
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        var x_section = this.getSectionInnerHTML(parsedState.sections[document.getElementById('main-cart-items').dataset.id], ".totals__subtotal-value");
        if (!$('#cart_subscribe_radio').is(":checked")) {
          var price = parseFloat(x_section.replace("$", ""))
          var total = (price - (price * 5) / 100);
          $('.appstle-subsccribe-cart-discount').html('<b>5% (New Total $' + `${total.toFixed(2)})</b>`);
        }
        else {
          var price = parseFloat(x_section.replace("$", ""))

          $('.appstle-subsccribe-cart-discount').html('<b>5% (New Total $' + `${price.toFixed(2)})</b>`);
        }

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        await update_progress_bar(parsedState);
        this.disableLoading();
      })




  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }



  handleMinusButton() {
    if (this.input && this.input.value == 0) {
      this.minusButton.disabled = true;
    } else {
      if (this.minusButton)
        this.minusButton.disabled = false;
    }
  }

  getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
      .then((res) => res.json())
      .then((res) => res);
  }
}

customElements.define('quantity-input-new', QuantityInputNew);


var gift_cards = [31478736748586, 31478736781354, 31478736814122, 31478736846890]
async function update_progress_bar(data) {
  try {
    console.log("in cart flow")
    //get the query string to set the correct amounts for delivery
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var state = urlParams.get('state')

    if(state == "california"){
      var free_delivery = 7500;
    }
    else{
      var free_delivery = 6500;
    }

    var price_without_discounts = data.original_total_price

    var minimum_order = 4000;
    var has_selling_plan_allocation = false;
    var items = ((data || {}).items || [])
    var original_price = 0
    var found_gift_card = true;
    items.forEach(item => {
      if (Object.keys(item.selling_plan_allocation || {}).length > 0) {
        has_selling_plan_allocation = true;
      }
      if (!gift_cards.includes(item.id)) {
        if (item.original_line_price != item.final_line_price) {
          original_price += item.final_line_price
        }
        else {
          found_gift_card = true;
          original_price += item.original_line_price;
        }
      }
    })

    await update_checkout_button(data);

    if (has_selling_plan_allocation) {
      if(state == "california"){
       free_delivery = 7100;
      }
      else{
       free_delivery = 6500;
      }

      minimum_order = 3800;
    }

    const progress = document.getElementById("progress_bar_free_shipping");
    const progress_title = document.getElementById("progress_title");
    const price = document.querySelector(".totals__subtotal-value");
    let diff = free_delivery - price_without_discounts;
    let order_difference = minimum_order - price_without_discounts;
    if (order_difference <= 0) {
      if (diff >= 0) {
        diff = (diff / 100).toFixed(2);
        if(state == "california"){
          progress_title.innerHTML = `You are $` + diff + ` Away from Free Delivery ($9.95 fee).`
        }
        else{
          progress_title.innerHTML = `You are $` + diff + ` Away from Free Delivery ($6.95 fee).`
        }

      } else {
        progress_title.innerHTML = `Hooray! You unlocked free delivery 🎉 `;

      }
    }
    else {
      minimum_order = (minimum_order / 100).toFixed(2)
      progress_title.innerHTML = `Your order is below the $${minimum_order} minimum order before discount.`
    }
    let percentage = ((original_price) / free_delivery) * 100;

    if (percentage >= 0) {

      progress.style = `width:${percentage}%`
    }
    var p = ((data.items_subtotal_price) / 100).toFixed(2);
    price.innerHTML = `$${p}`;
  } catch (error) {
    console.log(error)
  }

}


async function update_checkout_button(cart) {
  var original_price = 0;
  var found_gift_card = false;
  var minimum_order = 4000;
  cart.items.forEach(item => {
    if (!gift_cards.includes(item.id)) {
      if (item.original_line_price != item.final_line_price) {
        original_price += item.final_line_price
      }
      else {
        original_price += item.original_line_price;
      }
    } else {
      found_gift_card = true;
    }
  })
  await delaynew(100)
  if (found_gift_card && original_price < 4000) {
    document.querySelector("#end_checkout_div .cart__checkout-button").disabled = true;
    document.querySelector("#end_checkout_div .cart__checkout-button").innerHTML = "Invalid Order";
  }
  if (found_gift_card) {
    document.getElementById("cart_subscribe_radio").disabled = true;
    document.getElementById("subscribition_purchase").style = "pointer-events:none";

    $("#cart_onetime_radio").click()
  } else {
    document.getElementById("cart_subscribe_radio").disabled = false;
    document.getElementById("subscribition_purchase").style = "";
  }
  if (found_gift_card && original_price < minimum_order) {
    document.querySelector("#end_checkout_div .cart__checkout-button").disabled = true;
    document.querySelector("#end_checkout_div .cart__checkout-button").innerHTML = "Invalid Order";
    document.querySelector(".cart__dynamic-checkout-buttons.additional-checkout-buttons").style = "display: none!important; max-width: 60rem; margin: auto; width: 100%;"
  }
  else {
    document.querySelector("#end_checkout_div .cart__checkout-button").disabled = false;
    document.querySelector("#end_checkout_div .cart__checkout-button").innerHTML = "Checkout";
    //check for catering or group order and remove the quick checkout buttons
    if(cart.attributes["Delivery-Location-Id"] != 270576){
      document.querySelector(".cart__dynamic-checkout-buttons.additional-checkout-buttons").style = "display: block; max-width: 60rem; margin: auto; width: 100%;"
    }
  }

}
